import React, { useEffect } from "react"
import { Outlet, useParams } from "react-router-dom"

import { connect } from "scrivito"
import { DEFAULT_LOCALE } from "shared/constants/app-constants"
import { locales } from "shared/constants/locales"
import { useHelmet } from "shared/lib/useHelmet"

import I18n from "i18n"

import { LocaleRedirect } from "./LocaleRedirect"

// Locales would need to be loaded before anything else runs.
// We cannot wait here or prerendered content will not hydrate correctly.

function LocaleVerifierComponent() {
  const { locale } = useParams()

  useEffect(() => {
    if (locale && locales.includes(locale)) {
      I18n.changeLanguage(locale)
    }
  }, [locale, locales])

  useHelmet({ htmlAttributes: { lang: locale || DEFAULT_LOCALE } })

  if (!locale || !locales.includes(locale)) {
    return <LocaleRedirect />
  }

  return <Outlet />
}

export const LocaleVerifier = React.memo(connect(LocaleVerifierComponent))
